import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import DocumentHitsFormat from '@Components/Results/services/document-hits-format.service';
import { Card } from '@els/els-react--card';
import { ButtonWithIcon } from '@els/els-react--button';

function DocumentClaimsHit({ claimsText, closeClick, trackingAttrs }) {
  const claimsHit = DocumentHitsFormat.checkAndFormatHit(claimsText, 'claims');

  return claimsHit ? (
    <Card className="result-detail-panel u-els-margin-top-1o2 e2e-document-action-claims-hit">
      <div className="result-detail-panel-wrapper u-els-display-flex">
        <h4 className="u-els-margin-right-1o2 u-els-font-family-bold">Claims Hit:</h4>
        <div className="u-els-display-flex">
          <InnerHTML tag="div" className="u-els-font-size-base u-els-line-height-default" html={claimsHit} />
          <ButtonWithIcon
            type="link"
            data-e2e="claims-hit-close"
            iconOnly
            linkIconSize="s"
            linkOptions={['navigation']}
            sprite="ChevronDown"
            {...trackingAttrs}
            className="result-detail-panel-wrapper-close e2e-close"
            data-automationid="sub-menu-close"
            onClick={() => {
              closeClick();
            }}>
            Close Claim Hits
          </ButtonWithIcon>
        </div>
      </div>
    </Card>
  ) : null;
}

DocumentClaimsHit.propTypes = {
  claimsText: PropTypes.string.isRequired,
  closeClick: PropTypes.func.isRequired,
  // for analytics
  trackingAttrs: PropTypes.object.isRequired,
};

export default DocumentClaimsHit;
